// MIT License - Copyright (c) 2026 Doug McNall
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './CartSidebar.css';

const CartSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { cartItems, removeFromCart, updateQuantity, cartTotal, cartItemCount } = useCart();

  const total = cartTotal;
  const itemCount = cartItemCount;

  return (
    <>
      {/* Cart Toggle Button */}
      <div className={`cart-sidebar-toggle ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(!isOpen)}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="9" cy="21" r="1"></circle>
          <circle cx="20" cy="21" r="1"></circle>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
        </svg>
        {itemCount > 0 && <span className="cart-badge">{itemCount}</span>}
      </div>

      {/* Cart Sidebar */}
      <div className={`cart-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="cart-sidebar-header">
          <h3>Shopping Cart</h3>
          <button className="cart-close" onClick={() => setIsOpen(false)}>
            <i className="fa fa-times"></i>
          </button>
        </div>

        <div className="cart-sidebar-content">
          {cartItems.length === 0 ? (
            <div className="cart-empty">
              <p>Your cart is empty</p>
              <Link to="/shop/product" className="browse-products-button" onClick={() => setIsOpen(false)}>
                Browse Products
              </Link>
            </div>
          ) : (
            <>
              <div className="cart-items-list">
                {cartItems.map(item => (
                  <div key={item.id} className="cart-sidebar-item">
                    <div className="cart-item-image">
                      <img src={item.image} alt={item.name} />
                    </div>
                    <div className="cart-item-details">
                      <div className="cart-item-name">{item.name}</div>
                      <div className="cart-item-price">${item.price.toFixed(2)}</div>
                      <div className="cart-item-quantity">
                        <button onClick={() => updateQuantity(item.id, item.quantity - 1)}>-</button>
                        <span>{item.quantity}</span>
                        <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
                      </div>
                    </div>
                    <button className="cart-item-remove" onClick={() => removeFromCart(item.id)}>
                      <i className="fa fa-trash"></i>
                    </button>
                  </div>
                ))}
              </div>

              <div className="cart-sidebar-footer">
                <div className="cart-total">
                  <span>Total:</span>
                  <span className="cart-total-amount">${total.toFixed(2)}</span>
                </div>
                <Link to="/shop/cart" className="cart-view-button" onClick={() => setIsOpen(false)}>
                  View Cart
                </Link>
                <Link to="/shop/checkout" className="cart-checkout-button" onClick={() => setIsOpen(false)}>
                  Checkout
                </Link>
              </div>
            </>
          )}
        </div>
      </div>

    </>
  );
};

export default CartSidebar;
